export default "__VITE_ASSET__S7d$QLke__"